import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CoreApiService } from './coreapi.service';
import { loadCoreApis, loadCoreApisSuccess } from './coreapi.actions';
import { catchError, forkJoin, map, mergeMap, Observable, of } from 'rxjs';

const safeApi = <T>(source$: Observable<T>, key: string) =>
  source$.pipe(
    map((data) => ({
      success: true,
      data,
    })),
    catchError((error) => {
      console.error(`${key} API failed`, error);
      return of({
        success: false,
        error,
      });
    })
  );

@Injectable()
export class CoreApiEffects {
  private actions$ = inject(Actions);
  private coreApiService = inject(CoreApiService);

  loadCoreApis$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCoreApis),
      mergeMap(() =>
        forkJoin({
          info: safeApi(this.coreApiService.getCoreApiInfo(), 'info'),
          assetType: safeApi(this.coreApiService.getCoreApiAssetType(), 'assetType'),
          country: safeApi(this.coreApiService.getCoreApiCountry(), 'country'),
          currency: safeApi(this.coreApiService.getCoreApiCurrency(), 'currency'),
          industryGroup: safeApi(this.coreApiService.getCoreApiIndustryGroup(), 'industryGroup'),
          instType: safeApi(this.coreApiService.getCoreApiInstType(), 'instType'),
          authority: safeApi(this.coreApiService.getAuthority(), 'authority'),
        }).pipe(
          map((responses: any) => {
            const result: any = {};
            const failures: string[] = [];

            const mapByKey = (arr: any[], key: string) =>
              arr.reduce((acc, item) => {
                acc[item[key]] = item;
                return acc;
              }, {});

            const mappings: any = {
              assetType: 'asset_type_id',
              country: 'country_id',
              currency: 'currency_id',
              industryGroup: 'industry_group_id',
              info: 'core_id',
              instType: 'inst_type_id',
              instrumentTsInfo: 'ts_id',
              portfolioTsInfo: 'ts_id',
            };
            for (const [key, response] of Object.entries(responses)) {
              const resp: any = response;
              if (resp.success) {
                result[key] = resp.data;

                if (mappings[key] && resp.data?.data) {
                  result[key].mapedById = mapByKey(resp.data.data, mappings[key]);
                }
              } else {
                failures.push(key);
                result[key] = null;
              }
            }

            return loadCoreApisSuccess({
              data: result,
            });
          })
        )
      )
    )
  );
}
